import { createRoot } from 'react-dom/client';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || "https://cca495460931029fbdfcb1e51b82e4dd@o4510687228854272.ingest.de.sentry.io/4510687250546768",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0,
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: true,
  debug: true,
  environment: import.meta.env.MODE,
});

import { ThemeProvider } from 'next-themes';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import { AuthProvider } from './lib/AuthContext';
import { SettingsProvider } from './lib/SettingsContext';
import { MaintenanceProvider } from './lib/MaintenanceContext';
import { MaintenanceGate } from './app/components/MaintenanceGate';
import { ProtectedRoute } from './app/components/ProtectedRoute';
import { LoginPage } from './app/pages/LoginPage';
import { RegisterPage } from './app/pages/RegisterPage';
import { ResetPasswordPage } from './app/pages/ResetPasswordPage';
import App from './app/App';
import './styles/index.css';

const ErrorFallback = () => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', gap: '16px', fontFamily: 'sans-serif' }}>
    <h1 style={{ fontSize: '24px', fontWeight: 600 }}>Coś poszło nie tak</h1>
    <p style={{ color: '#666' }}>Wystąpił nieoczekiwany błąd. Spróbuj odświeżyć stronę.</p>
    <button
      onClick={() => window.location.reload()}
      style={{ padding: '8px 24px', borderRadius: '8px', border: '1px solid #ccc', cursor: 'pointer', background: '#fff' }}
    >
      Odśwież stronę
    </button>
  </div>
);

createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <AuthProvider>
        <SettingsProvider>
          <MaintenanceProvider>
          <MaintenanceGate>
            <BrowserRouter>
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route
                  path="/*"
                  element={
                    <ProtectedRoute>
                      <App />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </BrowserRouter>
          </MaintenanceGate>
        </MaintenanceProvider>
        </SettingsProvider>
      </AuthProvider>
      <Analytics />
    </ThemeProvider>
  </Sentry.ErrorBoundary>
);